import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=4e1f7d84"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=4e1f7d84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports